import { useMemo } from "react"

import { Flex, Spin, Typography } from "antd"
import { useSelector } from "react-redux"

import MileStonesComponent from "./MileStones"

import "./styles.less"

const { Text } = Typography

const MileStones = () => {
  const { totalStatistics, totalStatisticsFetching } = useSelector((state) => state.referrals)
  const mileStones = useMemo(() => {
    const mileStones = []
    const scheme = totalStatistics?.milestone_scheme
    if (!scheme) return []
    let order = 1
    for (const [key, value] of Object.entries(scheme)) {
      mileStones.push({
        reward: Number(key) / 100,
        alerts: Number(value),
        order: order
      })
      order++
    }
    return mileStones
  }, [totalStatistics])

  return (
    <Spin spinning={totalStatisticsFetching}>
      <Flex className="referrals-milestones" vertical gap={24}>
        <Flex vertical gap={8}>
          <Text className="title">Get alerts and reach milestones</Text>
          <Text className="description" type="secondary">
            In addition to the earnings from each Ethoca and Verifi alert, you’ll receive a bonus
            when all referred business reaches a certain amount of alerts combined (lifetime). View
            below.
          </Text>
        </Flex>
        <MileStonesComponent
          mileStones={mileStones}
          current={totalStatistics?.current_milestone ?? 0}
        />
      </Flex>
    </Spin>
  )
}

export default MileStones
